var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "yt-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.281,
    height: 10.116,
    viewBox: "0 0 14.281 10.116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Youtube",
    d: "M7.141,10.116c-.037,0-3.726-.035-4.856-.145-.054-.01-.119-.018-.194-.027A2.1,2.1,0,0,1,.71,9.356,3.141,3.141,0,0,1,.143,7.929,22.122,22.122,0,0,1,0,5.6V4.51A22.144,22.144,0,0,1,.143,2.182,3.142,3.142,0,0,1,.71.755a1.961,1.961,0,0,1,1.34-.6L2.141.146C4.117,0,7.108,0,7.138,0h.006c.03,0,3.021,0,5,.146l.091.009a1.96,1.96,0,0,1,1.34.6,3.147,3.147,0,0,1,.568,1.428,22.129,22.129,0,0,1,.143,2.328V5.6a22.136,22.136,0,0,1-.143,2.328,3.148,3.148,0,0,1-.568,1.428,1.962,1.962,0,0,1-1.338.6l-.092.01C10.163,10.11,7.171,10.116,7.141,10.116ZM5.666,2.882V6.923L9.524,4.91Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYtIcon);
export default __webpack_public_path__ + "static/media/yt-icon.09ff514f1167d02df727f388427ea0f6.svg";
export { ForwardRef as ReactComponent };